import React from 'react'
import Hero from '../Components/Hero/Hero'
import { Popular } from '../Components/Popular/Popular'
import Offersforu from '../Components/Offers/Offersforu';
import { NewCollections } from '../Components/NewCollections/NewCollections';
import NewsLetter from '../Components/NewsLetter/NewsLetter'
// import Footer from '../Components/Footer/Footer'


export const Shopicon = () => {
  return (
    <div>
        <Hero/>
        <Popular/>  
        <br /> <br /><br />  <br /><br />  <br />
        <NewCollections/> <br /> <br /><br /><br /><br /><br /> <hr /><br /> <br /><br />
        <NewsLetter/><br /> <br /><br /> 
     
       
    </div>
  )
}
